import { ForwardedRef, ReactElement, forwardRef } from 'react';

import { ListGroup } from 'react-bootstrap';
import { SelectTypes } from '@/common/Select/types';
import { getClasses } from '@/utils';

const SelectList = forwardRef(
  (props: SelectTypes.ListProps, ref: ForwardedRef<HTMLDivElement>): ReactElement => (
    <ListGroup {...props} className={getClasses('Select-List', props.className)} variant="flush" ref={ref} />
  )
);
SelectList.displayName = 'SelectList';

export default SelectList;
